import { render } from "./ModalShare.vue?vue&type=template&id=22e8d7fb&scoped=true"
import script from "./ModalShare.vue?vue&type=script&lang=js"
export * from "./ModalShare.vue?vue&type=script&lang=js"

import "./modalshare-responsive.css?vue&type=style&index=0&id=22e8d7fb&scoped=true&lang=css&external"
import "./ModalShare.vue?vue&type=style&index=1&id=22e8d7fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e8d7fb"]])

export default __exports__